module.exports = __webpack_public_path__ + "static/media/rec-icon.7dd3eeca.svg";